<template>
  <div>
    <v-btn color="white" class="mr-5" v-for="(n, i) in navItems" :key="i" @click="$router.push(n.path)">
      {{ $t(n.meta.linkKey) }}
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: function() {
    return {};
  },

  props: ["customer"],

  computed: {
    ...mapGetters(["role"]),
    navItems: function() {
      return this
        .$router
        .options
        .routes
        .filter(r => 
          r.path.startsWith("/" + this.customer) && 
          (!r.meta.requiresRole || r.meta.requiresRole.includes(this.role)) &&
          (!r.meta.type || r.meta.type != "hidden") &&
          r.path != this.$route.path
        )
    },
  },

  methods: {},

  components: {},
};
</script>

<style></style>
